// 开讲新版
// const liveMessages = require('../page/LiveMessages.user.page');
// const LiveComments = require('../page/LiveComments.page');
const Verify = () => import('../page/dayima/verify');

export default [
  // 实名认证
  {
    path: '/dayimaVerify',
    name: 'dayimaVerify',
    component: Verify,
    meta: {
      pageTitle: '实名认证',
      requiresAuth: true,
      authType: 'user'
    }
  },
  // 实名认证成功
  {
    path: '/dayimaVerify/success',
    name: 'dayimaVerifySuccess',
    component: () => import('../page/scholarships/verifiedSuccess/index.page'),
    meta: {
      pageTitle: '实名认证',
      requiresAuth: false,
      authType: 'user'
    }
  }
];



// WEBPACK FOOTER //
// ./src/user/router/dayima.js